import { render } from "./index.vue?vue&type=template&id=1f93854a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/home-sub-banner-edit/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f93854a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f93854a', __exports__)) {
    api.reload('1f93854a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=1f93854a", () => {
    api.rerender('1f93854a', render)
  })

}


export default __exports__